module.exports = __webpack_public_path__ + "img/buy-crypto.9cc82d8f.svg";